// The PTO lock. Decided 9 Oct 2026 (docs/QUESTIONS.md, DECISION 9 Oct, item B).
//
// Payroll has already processed a person's PTO up to TWO WEEKS BEFORE their latest payroll
// row's "Updated To Date" (accrued_through). Jeremy, 29 Oct 2026 (punch list S18/S19): INOVA
// dates the file two weeks ahead of what payroll has processed, so the file uploaded on 28 Oct,
// dated 8 Nov, had processed PTO through 25 Oct. Until then the lock WAS the Updated To Date and
// refused everybody's PTO for the fortnight ahead. Only the LOCK moves: accrued_through stays
// the file's date, because INOVA works the BALANCE forward to it (projection.ts anchors there).
//
// A PTO request touching any day on or before that date can no longer be submitted, cancelled,
// rescheduled or approved here:
// doing so would change history payroll has already paid out on. HR can, and every
// time HR does it is logged (QB1). Denying stays allowed, since it only releases hours
// (QB2). NTD and FIELD are never locked. A person with no payroll row has no lock (QB3).
import { addDays, mdy } from './dates.js';
/** How far INOVA's Updated To Date runs ahead of what payroll has processed (S18/S19). */
export const PAYROLL_LEAD_DAYS = 14;
/** The last day payroll has processed, from a payroll file's Updated To Date. */
export function processedThrough(updatedTo) {
    return addDays(updatedTo, -PAYROLL_LEAD_DAYS);
}
/** The last day payroll has processed for this person, or null when nothing is locked. */
export function lockDate(personId, balances) {
    const updatedTo = balances.get(personId)?.accruedThrough;
    return updatedTo ? processedThrough(updatedTo) : null;
}
/**
 * The lock date this request falls under, or null when it is not locked: PTO only, and only
 * when its first day is on or before its person's lock date. Time Off kinds are PTO, so they
 * are locked too (QB4).
 */
export function ptoLockedThrough(request, balances) {
    if (request.type !== 'PTO')
        return null;
    const subject = request.resourceIds[0];
    if (subject === undefined)
        return null;
    const lock = lockDate(subject, balances);
    return lock !== null && request.start <= lock ? lock : null;
}
/** The words people see, so the screen and every API refusal say the same thing. */
export function lockedMessage(lock, what = 'this request') {
    return `Payroll has already processed PTO through ${mdy(lock)}, and ${what} includes a day on or before it. ` +
        'It can no longer be changed here. Contact HR.';
}
//# sourceMappingURL=lock.js.map